/**
 * Browser notification helpers for incoming chat messages.
 * Permission is requested lazily — call `requestChatNotificationPermission`
 * from a user-gesture context (route enter, button click) so the prompt is
 * accepted by the browser.
 */

let permissionRequested = false;

export function requestChatNotificationPermission() {
  if (typeof window === "undefined") return;
  if (!("Notification" in window)) return;
  if (permissionRequested) return;
  if (Notification.permission !== "default") return;
  permissionRequested = true;
  Notification.requestPermission().catch(() => {});
}

export type ChatNotificationPayload = {
  title?: string
  body?: string
  tag?: string
};

export function showChatBrowserNotification(payload: ChatNotificationPayload = {}) {
  if (typeof window === "undefined") return;
  if (!("Notification" in window)) return;
  if (Notification.permission !== "granted") return;
  // Don't notify when the user is already looking at the tab.
  if (document.hasFocus() && document.visibilityState === "visible") return;

  const title = payload.title ?? "Nouveau message";
  const notification = new Notification(title, {
    body: payload.body,
    tag: payload.tag ?? "chat-unread",
  });
  notification.onclick = () => {
    window.focus();
    notification.close();
  };
}
